import { filter } from 'rxjs/operators';

export const ofType = (...types) =>
    filter((action) => action && types.includes(action.type));
